import { apolloClient } from "@td/ui";
import DELETE_TASK_MUTATION from "../mutations/delete-task.graphql";
import toastr from "../../toastr";
import { translate } from "@td/shared_utils";

const responseSelector = ({ data: { deleteCareTeamTask }}) => deleteCareTeamTask;

export default async (taskId) => {
  try {
    const data = await apolloClient.mutate({
      mutation: DELETE_TASK_MUTATION,
      variables: {
        taskId: taskId,
      },
    });

    return responseSelector(data);
  } catch (e) {
    toastr.error(
      translate(null, "care_team_tasks", "server_error")
    );
  }
};
